// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons_small-button__vMwmO {
  width: 50px;
}

.buttons_large-button__Bzu7S {
  width: 150px;
}

.buttons_small_light_green__m9gxi {
  width: fit-content;
  background-color: var(--green-light);
  border: 2px solid var(--green-light);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #2e706c;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.buttons_small_light_green__m9gxi:hover {
  background: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: white;
  transition: all 0.3s;
}
@media (max-width: 1199px) {
  .buttons_small_light_green__m9gxi {
    padding: 10px 15px;
  }
}
@media (max-width: 991px) {
  .buttons_small_light_green__m9gxi {
    font-size: 12px;
    padding: 8px 15px;
  }
}

.buttons_small_green__sIZZq {
  width: fit-content;
  min-width: 150px;
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: white;
  text-transform: uppercase;
  transform: scale(1);
  transition: all 0.3s;
  cursor: pointer;
}
.buttons_small_green__sIZZq:hover {
  background: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.buttons_small_green__sIZZq:active {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: white;
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .buttons_small_green__sIZZq {
    font-size: 12px;
    padding: 8px 15px;
    min-width: fit-content;
  }
}

.buttons_orange__tnntK {
  width: fit-content;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: white;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.buttons_orange__tnntK:hover {
  background: var(--secondary-color-hover);
  border: 2px solid var(--secondary-color-hover);
  transform: scale(102%);
  transition: all 0.3s;
}
.buttons_orange__tnntK:active {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  color: white;
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .buttons_orange__tnntK {
    font-size: 12px;
    padding: 10px 10px;
  }
}

.buttons_orange_outlined__gKWXk {
  width: fit-content;
  min-width: 150px;
  background-color: transparent;
  border: 2px solid var(--secondary-color);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--secondary-color);
  text-transform: uppercase;
  cursor: pointer;
}
.buttons_orange_outlined__gKWXk:hover {
  background: var(--secondary-color-hover);
  border: 2px solid var(--secondary-color-hover);
  transform: scale(102%);
  color: white;
  transition: all 0.3s;
}
.buttons_orange_outlined__gKWXk:active {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  color: white;
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .buttons_orange_outlined__gKWXk {
    font-size: 12px;
    padding: 8px 10px;
  }
}

.buttons_green_outlined__DbsGy {
  width: fit-content;
  min-width: 150px;
  background-color: transparent;
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.buttons_green_outlined__DbsGy:hover {
  background: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  color: white;
  transform: scale(102%);
  transition: all 0.3s;
}
.buttons_green_outlined__DbsGy:active {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: white;
  transform: scale(0.98);
  transition: all 0.3s;
}
@media (max-width: 991px) {
  .buttons_green_outlined__DbsGy {
    font-size: 12px;
    padding: 8px 10px;
    min-width: 100px;
  }
}

.buttons_light_green_outlined__1l\\+iv {
  width: fit-content;
  background-color: transparent;
  border: 2px solid var(--green-light);
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--green-light);
  text-transform: uppercase;
  cursor: pointer;
}
.buttons_light_green_outlined__1l\\+iv:hover {
  background: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  color: white;
  transition: all 0.3s;
}
.buttons_light_green_outlined__1l\\+iv:active {
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  color: white;
  transition: all 0.3s;
}

.buttons_round_button__AlrFB {
  background-color: transparent;
  width: 35px;
  height: 35px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}
.buttons_round_button__AlrFB:hover {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  color: white;
  transition: all 0.3s;
}

.buttons_round_dashed_button__-7IZi {
  background-color: var(--field-focus-color);
  display: inline;
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  padding-bottom: 3px;
  min-width: 25px;
  color: var(--primary-color);
  border: 1px dashed var(--primary-color);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}
.buttons_round_dashed_button__-7IZi:hover {
  background-color: var(--primary-color-hover);
  border: 2px solid var(--primary-color-hover);
  color: white;
  transition: all 0.3s;
}
.buttons_round_dashed_button__-7IZi:focus {
  outline: 2px solid var(--field-focus-color);
  outline-offset: 2px;
}

.buttons_disabled__d0zSg {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Buttons/Button/buttons.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,oCAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AACF;AACE;EACE,gCAAA;EACA,sCAAA;EACA,YAAA;EACA,oBAAA;AACJ;AAEE;EArBF;IAsBI,kBAAA;EACF;AACF;AACE;EAzBF;IA0BI,eAAA;IACA,iBAAA;EAEF;AACF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAEF;AAAE;EACE,sCAAA;EACA,4CAAA;EAEA,sBAAA;EACA,oBAAA;AACJ;AAEE;EACE,sCAAA;EACA,sCAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AAAJ;AAGE;EAhCF;IAiCI,eAAA;IACA,iBAAA;IACA,sBAAA;EAAF;AACF;;AAGA;EACE,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAAF;AAEE;EACE,wCAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,wCAAA;EACA,wCAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAIE;EA7BF;IA8BI,eAAA;IACA,kBAAA;EADF;AACF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;AADF;AAGE;EACE,wCAAA;EACA,8CAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;AADJ;AAIE;EACE,wCAAA;EACA,wCAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AAFJ;AAKE;EA9BF;IA+BI,eAAA;IACA,iBAAA;EAFF;AACF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAFF;AAIE;EACE,sCAAA;EACA,4CAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AAFJ;AAKE;EACE,sCAAA;EACA,sCAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AAHJ;AAME;EA/BF;IAgCI,eAAA;IACA,iBAAA;IACA,gBAAA;EAHF;AACF;;AAMA;EACE,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AAHF;AAKE;EACE,sCAAA;EACA,4CAAA;EACA,YAAA;EACA,oBAAA;AAHJ;AAME;EACE,sCAAA;EACA,sCAAA;EACA,YAAA;EACA,oBAAA;AAJJ;;AAQA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AALF;AAOE;EACE,wCAAA;EACA,wCAAA;EACA,YAAA;EACA,oBAAA;AALJ;;AASA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,uCAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AANF;AAQE;EACE,4CAAA;EACA,4CAAA;EACA,YAAA;EACA,oBAAA;AANJ;AASE;EACE,2CAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,YAAA;EACA,mBAAA;AARF","sourcesContent":[".small-button {\n  width: 50px;\n}\n\n.large-button {\n  width: 150px;\n}\n\n.small_light_green {\n  width: fit-content;\n  background-color: var(--green-light);\n  border: 2px solid var(--green-light);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: #2e706c;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    color: white;\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 1199px) {\n    padding: 10px 15px;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 8px 15px;\n  }\n}\n\n.small_green {\n  width: fit-content;\n  min-width: 150px;\n  background-color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: white;\n  text-transform: uppercase;\n  transform: scale(1);\n  transition: all 0.3s;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n\n    transform: scale(102%);\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    color: white;\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 8px 15px;\n    min-width: fit-content;\n  }\n}\n\n.orange {\n  width: fit-content;\n  background-color: var(--secondary-color);\n  border: 2px solid var(--secondary-color);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: white;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background: var(--secondary-color-hover);\n    border: 2px solid var(--secondary-color-hover);\n    transform: scale(102%);\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    color: white;\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 10px 10px;\n  }\n}\n\n.orange_outlined {\n  width: fit-content;\n  min-width: 150px;\n  background-color: transparent;\n  border: 2px solid var(--secondary-color);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--secondary-color);\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--secondary-color-hover);\n    border: 2px solid var(--secondary-color-hover);\n    transform: scale(102%);\n    color: white;\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    color: white;\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 8px 10px;\n  }\n}\n\n.green_outlined {\n  width: fit-content;\n  min-width: 150px;\n  background-color: transparent;\n  border: 2px solid var(--primary-color);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--primary-color);\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    color: white;\n    transform: scale(102%);\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    color: white;\n    transform: scale(0.98);\n    transition: all 0.3s;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 8px 10px;\n    min-width: 100px;\n  }\n}\n\n.light_green_outlined {\n  width: fit-content;\n  background-color: transparent;\n  border: 2px solid var(--green-light);\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--green-light);\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    color: white;\n    transition: all 0.3s;\n  }\n\n  &:active {\n    background-color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    color: white;\n    transition: all 0.3s;\n  }\n}\n\n.round_button {\n  background-color: transparent;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    color: white;\n    transition: all 0.3s;\n  }\n}\n\n.round_dashed_button {\n  background-color: var(--field-focus-color);\n  display: inline;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1;\n  padding-bottom: 3px;\n  min-width: 25px;\n  color: var(--primary-color);\n  border: 1px dashed var(--primary-color);\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background-color: var(--primary-color-hover);\n    border: 2px solid var(--primary-color-hover);\n    color: white;\n    transition: all 0.3s;\n  }\n\n  &:focus {\n    outline: 2px solid var(--field-focus-color);\n    outline-offset: 2px;\n  }\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"small-button": `buttons_small-button__vMwmO`,
	"large-button": `buttons_large-button__Bzu7S`,
	"small_light_green": `buttons_small_light_green__m9gxi`,
	"small_green": `buttons_small_green__sIZZq`,
	"orange": `buttons_orange__tnntK`,
	"orange_outlined": `buttons_orange_outlined__gKWXk`,
	"green_outlined": `buttons_green_outlined__DbsGy`,
	"light_green_outlined": `buttons_light_green_outlined__1l+iv`,
	"round_button": `buttons_round_button__AlrFB`,
	"round_dashed_button": `buttons_round_dashed_button__-7IZi`,
	"disabled": `buttons_disabled__d0zSg`
};
export default ___CSS_LOADER_EXPORT___;
